import type { OriginalItemTypes } from "@memorang/types";

const PTE_FEEDBACK_SUPPORTED_CODES: ReadonlySet<OriginalItemTypes> = new Set([
	"FIBTIL",
	"FIBTIL_CORE",
	"FIBDPR",
	"FIBDPR_CORE",
	"FIBDDR",
	"FIBDDR_CORE",
	"WFDL",
	"WFDL_CORE",
	"HCSL",
	"HCSL_CORE",
	"HIWL",
	"HIWL_CORE",
	"ROPR",
	"ROPR_CORE",
]);

export const isPteFeedbackAgentItem = (itemType?: OriginalItemTypes): boolean =>
	itemType != null && PTE_FEEDBACK_SUPPORTED_CODES.has(itemType);

export const PTE_FEEDBACK_AGENT_ID = 74;
